var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.34 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.87,5.22H27.74v-.7a1.3,1.3,0,0,0-1.3-1.3H24.33a4.52,4.52,0,0,0-8.66,0h-2.1a1.31,1.31,0,0,0-1.31,1.3v.7H7.13a1.3,1.3,0,0,0-1.3,1.31V38.7A1.3,1.3,0,0,0,7.13,40H32.87a1.3,1.3,0,0,0,1.3-1.3V6.53A1.31,1.31,0,0,0,32.87,5.22Zm-18,.61h1.91a1.31,1.31,0,0,0,1.31-1.31,1.91,1.91,0,1,1,3.82,0,1.31,1.31,0,0,0,1.3,1.31h1.92v2H14.87Zm10.3,26.34H14.83a1.31,1.31,0,0,1,0-2.61H25.17a1.31,1.31,0,0,1,0,2.61Zm0-6.94H14.83a1.3,1.3,0,1,1,0-2.6H25.17a1.3,1.3,0,0,1,0,2.6Zm0-6.93H14.83a1.31,1.31,0,0,1,0-2.61H25.17a1.31,1.31,0,0,1,0,2.61Z",
    transform: "translate(-5.83)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseMenuIcon);
export default __webpack_public_path__ + "static/media/case_menu_icon.c7d2aedc.svg";
export { ForwardRef as ReactComponent };